import { endpoints } from '../../../constants/routesAndApisConstants';
import { backendFetch } from '../../../common/fetch/backendFetch';

const fetchRpcAction = async (payload: Record<string, string>) => {
  try {
    const response = await backendFetch(endpoints.MOBILE_TRAVEL_PLAN, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(payload),
    });
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return await response.json();
  } catch (error) {
    throw new Error(String(error));
  }
};

export default fetchRpcAction;
